import { useLanguageStore } from '@/store/language'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

export function initLanguage() {
  const router = useRouter()
  const languageStore = useLanguageStore()

  // read the language from the querystring
  const language = new URLSearchParams(window.location.search).get('language')
  if (languageStore.isValidLanguage(language)) {
    languageStore.setLanguage(language)
    // get the querystring without the language parameter
    const url = new URL(window.location.href)
    url.searchParams.delete('language')
    router.replace(`${url.pathname}${url.search}`)
  }
}

export function useLanguageSwitcher() {
  const languageStore = useLanguageStore()
  const { language: currentLanguage } = storeToRefs(languageStore)

  const switchLanguage = () => {
    const otherLanguage = languageStore.languages.find(
      (lang) => lang.name !== currentLanguage.value
    )

    if (otherLanguage) languageStore.setLanguage(otherLanguage.name)
  }

  return switchLanguage
}
